export const passAnalyzer = (str, index, matchString) => {
  const validShots = new Set(["CS", "LS", "H"]);
  const validPass = new Set(["XSP", "XLP", "XC", "XTB"]);

  const arr = str.split("-");
  const currentPlayer = arr[0] + arr[1];
  const prevIndex = index;
  const currentTeam = arr[0];

  if (validShots.has(arr[2]) && prevIndex >= 0 && arr[8] === "X") {
    for (let i = prevIndex; i >= 0; i--) {
      const arr = matchString[i].split("-");
      if (
        arr[0] !== currentTeam &&
        arr[2]?.charAt(0) !== "X" &&
        parseInt(arr[3]) > 0
      ) {
        break;
      }
      if (arr[0] + arr[1] === currentPlayer) {
        if (validPass.has(arr[2])) {
          return "Possible Key Pass";
        }
      }
    }
  }
  return "";
};

export const freeKickAnalyzer = (str, index, matchString) => {
  const validKicks = new Set(["FK", "PK"]);
  const validFouls = new Set(["F", "YC", "RC"]);
  const validFoulAttribute = new Set(["OFF", "HB"]);

  const arr = str.split("-");
  const prevIndex = index;
  const currentTeam = arr[0];

  if (validKicks.has(arr[8]) && prevIndex >= 0) {
    for (let i = prevIndex; i >= 0; i--) {
      const arr = matchString[i].split("-");
      if (arr[0] !== currentTeam && arr[2].charAt(0) !== "X") {
        if (!(validFouls.has(arr[8]) || validFoulAttribute.has(arr[2]))) {
          return "Possible Missed Foul";
        }
        break;
      }
    }
  }
  return "";
};
